URL={
  "List":"/mast/measureUnitmng/measureUnit/list",//计量单位管理-查询计量单位
	"ADD":"/mast/measureUnitmng/measureUnit/add",//计量单位管理-添加计量单位
	"MODIFY":"/mast/measureUnitmng/measureUnit/modify",//计量单位管理-修改计量单位
	"FIND":"/mast/measureUnitmng/measureUnit/find",//计量单位管理-查询计量单位
	"DEL":"/mast/measureUnitmng/measureUnit/delete",//计量单位管理-删除计量单位
	"RESTORE":"/mast/measureUnitmng/measureUnit/restore"//计量单位管理-恢复已删除计量单位
}

/**
 * 加载平台资源
 * @param {} data 
 * @param {*} cb 
 */
async function loadPlatResource(data,cb){
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.List,data);
  if(cb&&resResult){
    cb(resResult);
  }
}




export const URL_PLATFORM_RESOURCE=URL;

export default{
  loadPlatResource
}


